<template>
  <div
    class="flex-shrink-0 w-52 pb-4 md:w-64 border rounded shadow-sm bg-white border-gray-100 flex flex-col cursor-pointer"
    @click="goToCourse()"
  >
    <div
      class="hidden md:block h-32 rounded-t overflow-hidden relative"
      :style="{ backgroundImage: thumbnail }"
    >
      <!-- Gradient Overlay -->
      <div class="absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent">
        <!-- Rating Stars -->
        <div
          v-if="card.rating_count > 0"
          class="absolute bottom-2 left-2 p-2"
        >
          <l-rating-stars
            :rating="card.rating"
            class="text-star-color"
          />
          <div class="text-xs text-white">
            {{ card.rating }} ({{ card.rating_count }} Ratings)
          </div>
        </div>
      </div>
    </div>
    <div
      class="md:hidden h-32 rounded-t overflow-hidden relative"
      :style="{ backgroundImage: thumbnailMobile }"
    >
      <!-- Gradient Overlay -->
      <div class="absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent">
        <!-- Rating Stars -->
        <div
          v-if="card.rating_count > 0"
          class="absolute bottom-2 left-2 p-2"
        >
          <l-rating-stars
            :rating="card.rating"
            class="text-star-color"
          />
          <div class="text-xs text-white">
            {{ card.rating }} ({{ card.rating_count }} Ratings)
          </div>
        </div>
      </div>
    </div>
    <div class="flex-grow mt-2 p-2">
      <p class="hidden md:block text-sm font-semibold text-text-primary">
        {{ card.title }}
      </p>
      <p class="md:hidden text-sm font-semibold text-text-primary">
        {{ truncatedCourseTitle }}
      </p>
      <p class="text-xs text-gray mt-2">
        {{ card.instructor }}
      </p>
      <p
        v-if="showLocation"
        class="text-xs text-gray mt-2"
      >
        {{ card.city }}, {{ card.state }}
      </p>
    </div>
    <div
      v-if="productType === 'VIDEO' || productType === 'PODCAST'"
      class="font-bold text-xs text-gray-500 mt-2 px-2"
    >
      Available 24/7
    </div>
    <div
      v-else-if="productType === 'TRENDING'"
      class="font-bold text-xs text-gray-500 mt-2 px-2"
    >
      <p
        v-if="card.productType === 'LIVE'"
        class="text-xs text-gray mt-2"
      >
        {{ card.city }}, {{ card.state }}
      </p>
      <div
        v-if="card.productType === 'VIDEO' || productType === 'PODCAST'"
        class="font-bold text-xs text-gray-500 mt-2 px-2"
      >
        Available 24/7
      </div>
      <div
        v-else-if="card.city !== 'Online'"
        class="font-bold text-xs text-gray-500 mt-2 px-2"
      >
        {{ card.date }} | <br class="block md:hidden" /> {{ card.session_start_timestamp }}- {{ card.session_end_timestamp }} {{ card.timezone }}
      </div>
    </div>
    <div
      v-else-if="card.date"
      class="font-bold text-xs text-gray-500 mt-2 px-2"
    >
      {{ card.date }} | <br class="block md:hidden" /> {{ card.session_start_timestamp }}- {{ card.session_end_timestamp }} {{ card.timezone }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollCard',
  props: {
    card: {
      type: Object,
      default: () => {},
    }, // Pass the card data as a prop
    productType: {
      type: String,
      default: 'VIDEO',
    },
    variant: {
      type: String,
      default: 'default',
    },
    showLocation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thumbnail() {
      return `url(https://summitproedu.imgix.net/${this.getCourseId()}.jpg?auto=enhance%2cformat&fit=crop&crop=faces&w=292&h=145)`;
    },
    thumbnailMobile() {
      return `url(https://summitproedu.imgix.net/${this.getCourseId()}.jpg?auto=enhance%2cformat&fit=crop&crop=faces&w=206&h=128)`;
    },
    truncatedCourseTitle() {
      const maxCharacters = 67;
      if (this.card.title.length > maxCharacters) {
        return this.card.title.slice(0, maxCharacters) + '...';
      }
      else {
        return this.card.title;
      }
    },
  },
  methods: {
    async goToCourse() {
      // cards from course recs have product type attached
      if (this.card.productType) {
        await window.open(`/course/${this.getCourseId()}/${this.card.slug}/#${this.card.productType}/${this.card.sessionId}`);
      }
      else {
        await window.open(`/course/${this.getCourseId()}/${this.card.slug}/#${this.productType}`);
      }
    },
    getCourseId() {
      const allowedTypes = [
        'VIDEO', 'PODCAST', 'TEXT',
      ];
      return allowedTypes.includes(this.productType) || this.variant === 'homepage' ? this.card.id : this.card.course_id;
    },
  },
};
</script>
